import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

register({
    onUpdate: (registration) => {
        // Автоматическое обновление после 5 секунд (можно настроить)
        setTimeout(() => {
            window.location.reload();
        }, 5000);

        // Опционально: показать уведомление о предстоящем обновлении
        alert('Новая версия приложения будет загружена через 5 секунд.');
    },
    onSuccess: (registration) => {
        console.log('ServiceWorker успешно зарегистрирован');
    }
});

reportWebVitals();